import { z } from 'zod';
/**
 * Generative UI render spec (frontend spec §5.5).
 * The AI response includes a `renderSpec` that drives which component
 * the client chooses to display the payload. New render kinds can be
 * registered client-side without touching the server prompt.
 */
export const RenderSpec = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('text'), text: z.string() }),
    z.object({
        kind: z.literal('table'),
        columns: z.array(z.object({ key: z.string(), label: z.string() })),
        rows: z.array(z.record(z.string(), z.unknown())),
    }),
    z.object({
        kind: z.literal('chart'),
        chartType: z.enum(['bar', 'line', 'area']),
        xKey: z.string(),
        yKey: z.string(),
        data: z.array(z.record(z.string(), z.unknown())),
        title: z.string().optional(),
    }),
    z.object({
        kind: z.literal('graph'),
        centerEntity: z.string(),
        hops: z.number().int().min(1).max(4).default(2),
    }),
    z.object({
        kind: z.literal('timeline'),
        events: z.array(z.object({
            date: z.string(),
            title: z.string(),
            description: z.string().optional(),
            sourceId: z.string().optional(),
        })),
    }),
    z.object({ kind: z.literal('dossierRef'), entityName: z.string() }),
]);
